import register from '../../../../global/js/registry';
export default register('m-nav-offcanvas', () => import(/* webpackMode: "lazy" */ './m-nav-offcanvas.controller'));
